import request from '../../axios/interceptor';
import API from '../../constant.api';

export interface ForgotPasswordResponse {
  message: string;
  email: string; // masked
  expiresInSeconds: number;
  resendAfterSeconds: number;
}

const headers = { 'Content-Type': 'application/json' };

// Both endpoints are public: they use the shared axios instance directly so no Authorization header is attached.

// Step 1 (also used for "Resend OTP"): emails a 6-digit OTP to the user's registered email
export const sendResetOtp = async (payload: {
  userName: string;
}): Promise<ForgotPasswordResponse> => {
  const { data } = await request.post(API.USER_FORGOT_PASSWORD, payload, {
    headers,
  });
  return data;
};

// Step 2: verifies the OTP and sets the new password
export const resetPassword = async (payload: {
  userName: string;
  otp: string;
  newPassword: string;
  confirmPassword: string;
}) => {
  const { data } = await request.post(API.USER_RESET_PASSWORD, payload, {
    headers,
  });
  return data;
};
